import { render, staticRenderFns } from "./ShingakuUnitRangeGroup.vue?vue&type=template&id=b229ee54&scoped=true&"
import script from "./ShingakuUnitRangeGroup.vue?vue&type=script&lang=js&"
export * from "./ShingakuUnitRangeGroup.vue?vue&type=script&lang=js&"
import style0 from "./ShingakuUnitRangeGroup.vue?vue&type=style&index=0&id=b229ee54&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b229ee54",
  null
  
)

export default component.exports